<ion-app>
  @if (isDesktopWebBlocked) {
    <ion-content class="ion-padding ion-text-center">
      <h1>Disponível apenas no celular</h1>
      <p>O Gymfyfit Web funciona em smartphones e tablets.</p>
      <p>Abra este link no Safari (iPhone) ou no Chrome (Android) e adicione à tela inicial.</p>
      <p>No Android, você também pode instalar pela Google Play.</p>
      <ion-button
        expand="block"
        href="https://play.google.com/store/apps/details?id=com.gymfyfit.app"
        target="_blank"
        rel="noopener noreferrer">
        Baixar na Google Play
      </ion-button>
    </ion-content>
  } @else if (isOffline) {
    <ion-content class="ion-padding ion-text-center">
      <h1>Sem conexão</h1>
      <p>Verifique sua internet e tente novamente.</p>
      <ion-button expand="block" (click)="retryConnection()">Tentar novamente</ion-button>
    </ion-content>
  } @else {
    <ion-router-outlet [animation]="getRouterAnimation()"></ion-router-outlet>
    @if (showBottomNav) {
      <app-bottom-nav
        [tabs]="navigationTabs"
        [activeTabId]="activeTabId"
        [profileImageUrl]="profileImageUrl"
        (tabSelected)="onTabSelected($event)">
      </app-bottom-nav>
    }
  }
</ion-app>
